<template>
  <div
    class="nup-awarded"
    :class="{ 'is-multi': images.length > 1, 'is-compact': showView }"
  >
    <div class="nup-awarded__cards">
      <img
        v-for="(src, index) in images"
        :key="index"
        class="nup-awarded__img"
        :src="src"
        :alt="showView ? copy.awardedAlt : copy.missedAlt"
      >
    </div>
    <div
      v-if="showView"
      data-nup-cta
      class="nup-awarded__cta"
    >
      <PrimaryButton
        :text="copy.view"
        @click="$emit('view')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { getCopy } from '../constants/copy';
import { useNupLang } from '../composables/use-nup-lang';
import PrimaryButton from './primary-button.vue';
const __sfc_main = {};
__sfc_main.props = {
  images: {
    type: Array,
    required: true
  },
  showView: {
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    isEn
  } = useNupLang();
  const copy = computed(() => getCopy(isEn.value));
  return {
    copy
  };
};
__sfc_main.components = Object.assign({
  PrimaryButton
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped>
.nup-awarded__cards {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.nup-awarded__img {
  display: block;
  width: 670px;
  height: 188px;
  object-fit: contain;
}

.nup-awarded__cta {
  margin-top: 40px;
}

.nup-page.is-pc .nup-awarded {
  width: 1200px;
  max-width: 100%;
}

.nup-page.is-pc .nup-awarded__cards {
  flex-direction: row;
  justify-content: center;
  gap: 16px;
}

.nup-page.is-pc .nup-awarded__img {
  width: 100%;
  max-width: 100%;
  height: auto;
}

.nup-page.is-pc .nup-awarded.is-compact .nup-awarded__img {
  width: 591px;
  height: 152px;
  object-fit: fill;
}

.nup-page.is-pc .nup-awarded.is-compact:not(.is-multi) {
  position: relative;
  width: 591px;
  margin: 0 auto;
}

.nup-page.is-pc .nup-awarded.is-compact:not(.is-multi) .nup-awarded__cta {
  position: absolute;
  top: 50%;
  right: 16px;
  z-index: 1;
  margin: 0;
  width: 148px;
  transform: translateY(-50%);
}

.nup-page.is-pc .nup-awarded.is-compact:not(.is-multi) .nup-awarded__cta >>> .nup-btn {
  width: 148px;
  height: 56px;
  font-size: 20px;
  background: #F56A08;
  border: none;
}

.nup-page.is-pc .nup-awarded.is-multi .nup-awarded__cta {
  width: 360px;
  margin: 40px auto 0;
}

.nup-page.is-pc .nup-awarded.is-multi .nup-awarded__cta >>> .nup-btn {
  width: 360px;
  height: 60px;
  font-size: 20px;
}
</style>
